import { httpClient } from './httpClient';

// SWRのデフォルトfetcher関数
const fetcher = (url) => httpClient.get(url).then((res) => res.data);

// SWRの設定
export const swrConfig = {
  fetcher,
  revalidateOnFocus: false,
  revalidateOnReconnect: true,
  errorRetryCount: 3,
  errorRetryInterval: 5000,
  onError: (error) => {
    console.error('SWR Error:', error);
  },
};

export { fetcher };
